import React from 'react'

const UserActivity = () => {
  return (
    <div>UserActivity</div>
  )
}

export default UserActivity